<template>
  <b-input-group>
    <template #prepend>
      <b-form-select v-model="selected_side" :options="options" />
    </template>
    <b-form-input
      v-model.number="current_value"
      type="number"
      :max="max"
      :min="min"
    />
    <template #append>
      <b-button variant="primary" @click="apply" :disabled="disable">
        <template v-if="submitting">
          <i class="fal fa-spinner fa-spin" />{{ " Applies..." }}
        </template>
        <template v-else>Apply</template>
      </b-button>
    </template>
  </b-input-group>
</template>

<script>
export default {
  name: "ToggleBatchButton",
  props: {
    max: {
      type: Number,
      default: 0,
    },
    min: {
      type: Number,
      default: 0,
    },
    submitting: {
      type: Boolean,
      default: false,
    },
    disable: {
      type: Boolean,
      default: false,
    },
    side: {
      type: String,
      default: null,
    },
    process: {
      type: String,
      default: null,
    },
    value: {
      type: Number,
      default: 0,
    },
    options: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    selected_side: {
      get() {
        return this.side;
      },
      set(value) {
        this.$emit("updateToggleSelector", { process: this.process, value });
      },
    },
    current_value: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("updateToggleValue", {
          process: this.process,
          value,
        });
      },
    },
  },
  methods: {
    apply() {
      this.$emit("applyToggle", this.process, this.selected_side);
    },
  },
};
</script>
